const lastRequestedKey = 'rss-last-requested';
const resourceStringsKey = 'rss-data';
const TIME_UNTIL_STORED_DATA_IS_EXPIRED = 1000 * 60 * 60 * 24; // 24 Hours

export const ResourceStringsLoaderService = function ResourceStringsLoaderService(
    LoggingApi,
    BdLocalize,
    $q,
    $window,
    ResourceStringsApi
) {
    const service = {};

    service.loadResourceStrings = function loadResourceStrings() {
        const dfd = $q.defer();
        const lastRequest = localStorage.getItem(lastRequestedKey);
        const currentTime = new Date().getTime();
        const isStoredDataDeprecated = lastRequest === null ? true : currentTime - parseInt(lastRequest, 10) > TIME_UNTIL_STORED_DATA_IS_EXPIRED;
        const retrievedOriginalData = localStorage.getItem(resourceStringsKey);
        if (isStoredDataDeprecated || !retrievedOriginalData) {
            ResourceStringsApi.get().then((resourceStrings) => {
                if (!resourceStrings) {
                    return;
                }

                BdLocalize.updateResourceStrings(JSON.parse(resourceStrings));

                try {
                    localStorage.setItem(resourceStringsKey, resourceStrings);
                    localStorage.setItem(lastRequestedKey, currentTime.toString());
                } catch (exc) {
                    // Don't log warning if the exception is because localStorage is out of space
                    if (exc instanceof DOMException
                        && (exc.code === 22
                            || exc.code === 1014
                            || exc.name === 'QuotaExceededError'
                            || exc.name === 'NS_ERROR_DOM_QUOTA_REACHED')) {
                        return;
                    }
                    LoggingApi.logWarningMessage(exc);
                }
                dfd.resolve();
            }).catch(() => {
                dfd.reject();
            });
        } else {
            BdLocalize.updateResourceStrings(JSON.parse(retrievedOriginalData));
            dfd.resolve();
        }
        return dfd.promise;
    };

    return service;
};

ResourceStringsLoaderService.$inject = [
    'LoggingApi',
    'BdLocalize',
    '$q',
    '$window',
    'ResourceStringsApi'
];
